var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from "react";
import styled from "styled-components";

// PRE-DEFINED TYPOGRAPHY STYLES
// Remeber to end the props with {...props} so they can be overwritten

export var Link = React.forwardRef(function (props, ref) {
  return React.createElement(
    AStyled,
    _extends({ ref: ref }, props),
    props.children
  );
});

var AStyled = styled.a.withConfig({
  displayName: "Link__AStyled",
  componentId: "sc-15sm5kw-0"
})(["color:", ";text-decoration:underline !important;"], function (props) {
  return props.theme.primaryDark;
});